/**
 * Status badge per KR e celle di periodo.
 * Stati:
 *   - raggiunto:  ● verde scuro
 *   - on_track:   ● ink
 *   - a_rischio:  ● ambra (#E5484D variation)
 *   - n_d:        ◦ grigio (no data)
 */
const COLORS = {
  raggiunto: { bg: 'var(--qp-success)', label: 'Raggiunto', char: '●' },
  on_track:  { bg: 'var(--qp-ink)', label: 'On-track',  char: '●' },
  a_rischio: { bg: '#E5484D', label: 'A rischio', char: '●' },
  n_d:       { bg: 'var(--qp-border)', label: 'n.d.',       char: '◦' },
};

export default function StatusBadge({ stato = 'n_d', size = 'sm', showLabel = false, title }) {
  const c = COLORS[stato] || COLORS.n_d;
  const dim = size === 'lg' ? 10 : size === 'md' ? 8 : 6;
  return (
    <span
      className="inline-flex items-center gap-1.5"
      title={title || c.label}
      data-testid={`status-badge-${stato}`}
    >
      <span
        className="inline-block rounded-full"
        style={{ width: dim, height: dim, backgroundColor: c.bg }}
        aria-hidden
      />
      {showLabel && (
        <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-soft">
          {c.label}
        </span>
      )}
    </span>
  );
}
